/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "FulfillmentMethodPromptTime": {
                                "values": {
                                  "FULFILLMENT_METHOD_PROMPT_TIME_AT_START_OF_NEW_ORDER": 0,
                                  "FULFILLMENT_METHOD_PROMPT_TIME_WHEN_TAPPING_PAY_OR_SEND": 1
                                }
                              },
                              "FulfillmentTypes": {
                                "fields": {
                                  "showPickupFulfillment": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "showShipmentFulfillment": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "fulfillmentMethodPromptingEnabled": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "fulfillmentMethodPromptTime": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.FulfillmentMethodPromptTime",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": "FULFILLMENT_METHOD_PROMPT_TIME_AT_START_OF_NEW_ORDER"
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.FulfillmentMethodPromptTime && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.FulfillmentTypes) {
  $root.addJSON(jsonData);
}

/**
 * Represents when to show the fulfillment method selection prompt, if it is enabled.
 * Deprecated with RST-46388. This was never used in production. Only the iOS POS app ever added support
 * for reading this, and it was never rolled out. The implementation was deleted in 6.82 https://github.com/squareup/ios-register/pull/135889
 * It's being replaced with ASR provided settings. https://github.com/squareup/go-square/pull/86887
 *
 * SOURCE FulfillmentMethodPromptTime @ squareup/devicesettings/profiles/v2/model/settings/common/fulfillment_types.proto at 13:1
 */
export const FulfillmentMethodPromptTime = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.FulfillmentMethodPromptTime').values;
/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE FulfillmentTypes @ squareup/devicesettings/profiles/v2/model/settings/common/fulfillment_types.proto at 30:1
 */
export const FulfillmentTypes = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.FulfillmentTypes');
fixType(FulfillmentTypes);
Builder.createAndAttachToType(FulfillmentTypes);